import { render, staticRenderFns } from "./NewTeamTask.vue?vue&type=template&id=76dd3713&"
import script from "./NewTeamTask.vue?vue&type=script&lang=js&"
export * from "./NewTeamTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports